import { IUserProfile } from "../../../Models/Profile/IUserProfile";
import { IResult } from "../../../Models/Result/IResult";
import { IProfileApi } from "./IProfileApi";
import { formatUrl, handleError } from "../ApiHelpers";
import { Result } from "../../../Models/Result/Result";
import axios from "axios";
import { IProfileContact } from "../../../Models/Profile/IProfileContact";
import { IAttendee } from "../../../Models/Attendees/IAttendee";
import { strToDate } from "../../../Tools/DateTime";


export class ProfileApi implements IProfileApi {

    private backendUrl: string;

    constructor(url: string) {
        this.backendUrl = url;
    }

    async getCokies() {
        //const url = formatUrl(this.backendUrl, `/api/Profile/GetCokies`);
        //const response = await axios.get(url);
    }


    async getLoginUserInfo(): Promise<IResult<IUserProfile>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/Profile/GetUserInfo`);
            const response = await axios.get(url);
            return response.data as IResult<IUserProfile>;
        }
        catch (error) {
            return handleError(error, "getLoginUserInfo");
        }
    }

    async changeEmail(email: string, emailConfirmation: string): Promise<IResult<string>> {
        try {

            const url = formatUrl(this.backendUrl, `/api/Profile/ChangeEmail`);
            const data = {
                email,
                emailConfirmation
            };
            const response = await axios({
                method: "post",
                url: url,
                data: data
            });
            return response.data as IResult<string>;
        }
        catch (error) {
            return handleError(error, "changeEmail");
        }
    }

    async changePassword(oldPassword: string, newPassword: string, confirmPassword: string): Promise<IResult<string>> {
        try {

            const url = formatUrl(this.backendUrl, `/api/Profile/ChangePassword`);
            const data = {
                oldPassword,
                newPassword,
                confirmPassword
            };
            const response = await axios({
                method: "post",
                url: url,
                data: data
            });
            return response.data as IResult<string>;
        }
        catch (error) {
            return handleError(error, "changeEmail");
        }
    }

    async getProfileContact(): Promise<IResult<IProfileContact>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/Profile/GetProfileContacts`);
            const response = await axios.get(url);
            return response.data as IResult<IProfileContact>;
        }
        catch (error) {
            return handleError(error, "getProfileContact");
        }
    }

    async saveProfileContact(contacts: IProfileContact): Promise<IResult<IProfileContact>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/Profile/SaveProfileContacts`);
            const response = await axios.post(url, contacts);
            return response.data as IResult<IProfileContact>;
        }
        catch (error) {
            return handleError(error, "getProfileContact");
        }
    }

    async checkEmail(email: string): Promise<IResult<boolean>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/Profile/CheckEmail`);
            const response = await axios.post(url, email, { headers: { 'Content-Type': 'text/plain' }});
            return response.data as IResult<boolean>;
        }
        catch (error) {
            return handleError(error, "checkEmail");
        }
    }

    async getAttendees(): Promise<IResult<IAttendee[]>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/Profile/GetAttendees`);
            const response = await axios.get(url);
            const data = response.data as IResult<IAttendee[]>;
            if (data.data) {
                data.data.forEach(function (part, index) {
                    if (data.data) {
                        data.data[index].dateOfBirth = strToDate(part.dateOfBirth.toString());
                    }
                }, response.data);
            }

            return data;
        }
        catch (error) {
            return handleError(error, "getProfileContact");
        }
    }
}